import { Path, Svg } from '@react-pdf/renderer';

const PdfSiBackpack = () => (
  <Svg width="50" height="50" viewBox="0 0 24 24">
    <Path
      d="M9.75 7V6.75C9.75 5.64543 10.6454 4.75 11.75 4.75H12.25C13.3546 4.75 14.25 5.64543 14.25 6.75V7"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <Path
      d="M5.75 13V18C5.75 18.6904 6.30964 19.25 7 19.25H17C17.6904 19.25 18.25 18.6904 18.25 18V13C18.25 9.54822 15.4518 6.75 12 6.75C8.54822 6.75 5.75 9.54822 5.75 13Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinejoin="round"
    />
    <Path d="M9.75 14.25H14.25" stroke="currentColor" strokeWidth={2} strokeLinejoin="round" />
  </Svg>
);
export default PdfSiBackpack;
